import { fetchWithAuth, getCSRFToken } from './authApi';

export async function addFavoriteCasino(casinoId: number): Promise<void> {
    const csrf = await getCSRFToken();
    const res = await fetchWithAuth(`/api/v1/users/me/favorites/${casinoId}`, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrf },
    });
    if (!res.ok) {
        let msg = 'Failed to add favorite';
        try {
            const data = await res.json();
            if (data?.error) msg = data.error;
        } catch { /* ignore non-JSON */ }
        throw new Error(msg);
    }
}

export async function removeFavoriteCasino(casinoId: number): Promise<void> {
    const csrf = await getCSRFToken();
    const res = await fetchWithAuth(`/api/v1/users/me/favorites/${casinoId}`, {
        method: 'DELETE',
        headers: { 'X-CSRF-Token': csrf },
    });
    if (!res.ok) {
        let msg = 'Failed to remove favorite';
        try {
            const data = await res.json();
            if (data?.error) msg = data.error;
        } catch { /* ignore non-JSON */ }
        throw new Error(msg);
    }
}
